var _clipPath, _clipPath2, _clipPath3, _clipPath4, _clipPath5, _clipPath6, _clipPath7, _clipPath8, _clipPath9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGuy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 2402 2626",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-1152.19,-12147.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_1",
    transform: "matrix(0.968258,0,0,0.748329,1152.19,12147.5)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 2480.32,
    height: 3507.87,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.03278,3.70901e-17,-2.86655e-17,1.33631,-6272.01,-10807.9)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.18122,-3.27855e-17,2.77556e-17,1,1210.14,839.45)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.05274,-1.36846e-48,0,1,-271.391,0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4940.78,9153.23C4940.78,9153.23 4863.99,9183.64 4767.4,9210.89C4711.14,9226.77 4658.34,9255.01 4605.39,9305.77C4581.27,9328.9 4565.45,9354.97 4565.46,9391.17C4565.47,9439.59 4590.93,9477.7 4639.3,9493.9C4798.72,9547.28 5147.72,9487.04 5147.72,9487.04C5147.72,9487.04 5700.43,9614.38 5710.16,9367.3C5710.98,9346.56 5689.23,9324.92 5665.85,9295.13C5626.09,9244.47 5555.49,9217.72 5501.38,9199.79C5403.13,9167.23 5315.77,9150.19 5321.46,9152.55C5321.49,9152.56 4940.78,9153.23 4940.78,9153.23Z",
    style: {
      fill: "rgb(20,42,138)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.846581,5.21746e-33,-2.60873e-33,1,3141.32,38.9422)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2056.25,9131.13C2091.43,9121.08 2112.77,9114.29 2112.77,9114.29C2112.77,9114.29 2586.19,9113.62 2586.15,9113.61C2581.87,9112.18 2619.91,9117.85 2677.65,9129.75C2598.29,9159.86 2593.62,9227.92 2597.59,9238.86C2601.9,9250.72 2615.98,9290.33 2687.28,9286.79C2758.58,9283.24 2645.33,9374.97 2535.45,9376.01C2425.56,9377.06 1976.76,9234.76 1976.76,9234.76C1976.76,9234.76 2051.91,9218.31 2115.6,9221.72C2169.44,9224.61 2144.24,9165.95 2056.25,9131.13Z",
    style: {
      fill: "rgb(14,27,91)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.975569,-0.219691,0.219691,0.975569,-1793.64,1255.88)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5052.65,9373.79C5052.65,9373.79 5135.51,9343.05 5164.85,9392C5185.44,9426.35 5198.5,9447.77 5227.46,9474.14C5253.17,9497.55 5313.17,9578 5294.51,9602.38C5278.97,9622.67 5247.64,9649.64 5180.52,9572.95C5107.82,9489.88 4994.21,9518.01 4994.21,9518.01L5052.65,9373.79Z",
    style: {
      fill: "rgb(255,200,161)"
    }
  }), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5052.65,9373.79C5052.65,9373.79 5135.51,9343.05 5164.85,9392C5185.44,9426.35 5198.5,9447.77 5227.46,9474.14C5253.17,9497.55 5313.17,9578 5294.51,9602.38C5278.97,9622.67 5247.64,9649.64 5180.52,9572.95C5107.82,9489.88 4994.21,9518.01 4994.21,9518.01L5052.65,9373.79Z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_-\\u041A\\u0440\\u0438\\u0432\\u0430\\u044F-",
    transform: "matrix(0.825898,0.185986,-0.219691,0.975569,5081.74,-103.04)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2460.37,9238.34C2460.37,9238.34 2518.65,9265.95 2523.85,9299.25C2529.05,9332.55 2589.83,9328.12 2589.83,9328.12L2470.13,9368.79L2431.11,9313.62L2460.37,9238.34Z",
    style: {
      fill: "rgb(240,163,111)"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.987146,-0.159821,0.159821,0.987146,-1292.48,826.052)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5051.18,9522.76C5051.18,9522.76 4399.22,9640.55 4396.7,9412.88C4395.26,9282.59 4564.09,9294.34 4809.03,9335.86C4937.58,9357.66 5054,9362.86 5054.15,9362.86C5054.33,9362.86 5106.45,9384.7 5107.66,9440.95C5109.1,9507.58 5051.18,9522.76 5051.18,9522.76Z",
    style: {
      fill: "rgb(20,42,138)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.0533,-4.13445e-34,-1.53494e-34,1,2645.44,38.9422)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2481.66,9297.03C2488.99,9357.58 2437.95,9380.18 2437.95,9380.18C2437.95,9380.18 2248.55,9447.01 2071.85,9469.64L2071.17,9469.67C2071.17,9469.67 2118.87,9431.94 2136.15,9406.21C2153.43,9380.48 2215.84,9378.57 2245.88,9386.29C2245.88,9386.29 2236.24,9359.86 2350.71,9346.61C2457.54,9334.25 2480.89,9313.33 2481.66,9297.03Z",
    style: {
      fill: "rgb(14,27,91)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1.17614,-0.173049,-0.151225,0.981526,12424.3,1113.53)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5052.65,9373.79C5052.65,9373.79 5135.51,9343.05 5164.85,9392C5185.44,9426.35 5198.5,9447.77 5227.46,9474.14C5253.17,9497.55 5313.4,9564.81 5294.74,9589.19C5279.21,9609.48 5251.65,9647.62 5180.52,9572.95C5110.94,9499.9 4987.74,9485.4 4987.74,9485.4L5052.65,9373.79Z",
    style: {
      fill: "rgb(255,200,161)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1.17614,-0.173049,-0.151225,0.981526,12424.3,1113.53)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5052.65,9373.79C5052.65,9373.79 5135.51,9343.05 5164.85,9392C5185.44,9426.35 5198.5,9447.77 5227.46,9474.14C5253.17,9497.55 5313.4,9564.81 5294.74,9589.19C5279.21,9609.48 5251.65,9647.62 5180.52,9572.95C5110.94,9499.9 4987.74,9485.4 4987.74,9485.4L5052.65,9373.79Z",
    style: {
      fill: "rgb(255,200,161)"
    }
  }), _clipPath2 || (_clipPath2 = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5052.65,9373.79C5052.65,9373.79 5135.51,9343.05 5164.85,9392C5185.44,9426.35 5198.5,9447.77 5227.46,9474.14C5253.17,9497.55 5313.4,9564.81 5294.74,9589.19C5279.21,9609.48 5251.65,9647.62 5180.52,9572.95C5110.94,9499.9 4987.74,9485.4 4987.74,9485.4L5052.65,9373.79Z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip2)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.703838,-0.124091,-0.128093,0.996238,7855.46,290.148)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2062.88,9577.81C2062.88,9577.81 2229.78,9524.98 2284.52,9522.35C2284.54,9520.93 2284.44,9519.45 2284.22,9517.92C2277.29,9468.26 2241.15,9380.77 2241.15,9380.77C2241.15,9380.77 2215.83,9422.37 2171.13,9485.01C2146.49,9519.53 2062.88,9577.81 2062.88,9577.81Z",
    style: {
      fill: "rgb(240,163,111)"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1.01615,0.118036,0.120787,0.993009,9041.03,-477.745)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5051.18,9522.76C5051.18,9522.76 4366.81,9634.26 4364.29,9406.59C4362.85,9276.3 4564.09,9294.34 4809.03,9335.86C4937.58,9357.66 5054,9362.86 5054.15,9362.86C5054.33,9362.86 5106.45,9384.7 5107.66,9440.95C5109.1,9507.58 5051.18,9522.76 5051.18,9522.76Z",
    style: {
      fill: "rgb(20,42,138)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,6161.06,8001.31)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1007.97,1084.55C1007.97,1084.55 872.173,1148.03 784.788,1188.87C738.468,1210.52 701.953,1248.76 682.456,1296.02C649.816,1375.15 602.51,1489.84 602.51,1489.84L817.958,1580.35L836.241,1544.5C836.241,1544.5 888.09,1706.17 888.555,1762.93C889.02,1819.69 871.641,1993.4 871.641,1993.4C871.641,1993.4 995.013,2040.86 1113.86,2040.86C1253.6,2040.86 1347.11,1992.42 1347.11,1992.42C1347.11,1992.42 1323.59,1800.68 1325,1753.94C1326.4,1707.2 1379.05,1541.88 1379.05,1541.88L1394.57,1580.91L1617.67,1492.78C1617.67,1492.78 1566.71,1373.8 1532.5,1293.94C1512.98,1248.36 1477.54,1211.43 1432.8,1190.06C1345.28,1148.24 1206.1,1081.74 1206.1,1081.74L1007.97,1084.55Z",
    style: {
      fill: "rgb(9,89,217)"
    }
  }), _clipPath3 || (_clipPath3 = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1007.97,1084.55C1007.97,1084.55 872.173,1148.03 784.788,1188.87C738.468,1210.52 701.953,1248.76 682.456,1296.02C649.816,1375.15 602.51,1489.84 602.51,1489.84L817.958,1580.35L836.241,1544.5C836.241,1544.5 888.09,1706.17 888.555,1762.93C889.02,1819.69 871.641,1993.4 871.641,1993.4C871.641,1993.4 995.013,2040.86 1113.86,2040.86C1253.6,2040.86 1347.11,1992.42 1347.11,1992.42C1347.11,1992.42 1323.59,1800.68 1325,1753.94C1326.4,1707.2 1379.05,1541.88 1379.05,1541.88L1394.57,1580.91L1617.67,1492.78C1617.67,1492.78 1566.71,1373.8 1532.5,1293.94C1512.98,1248.36 1477.54,1211.43 1432.8,1190.06C1345.28,1148.24 1206.1,1081.74 1206.1,1081.74L1007.97,1084.55Z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1192.21,1145.23C1192.21,1145.23 1304.6,1197.71 1382.93,1234.3C1427.03,1254.89 1479.39,1244.54 1512.34,1208.71C1512.34,1208.71 1512.34,1208.71 1512.34,1208.71L1142.91,1029.15L1192.21,1145.23Z",
    style: {
      fill: "rgb(23,64,212)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M830.695,1608.08L551.729,1481.39C551.729,1481.39 655.914,1488.55 725.548,1493.34C764.8,1496.04 803.564,1483.37 833.647,1458.01C848.137,1445.79 860.368,1435.48 860.368,1435.48C860.368,1435.48 872.552,1493.66 884.677,1551.56C898.443,1617.3 958.24,1663.07 1025.29,1659.18C1067.29,1656.75 1115.07,1653.99 1158.73,1651.46C1241.35,1646.68 1311.8,1589.92 1334.04,1510.2C1346.51,1465.49 1357.32,1426.75 1357.32,1426.75C1357.32,1426.75 1377.67,1442.86 1398.23,1459.13C1425.51,1480.72 1459.38,1492.27 1494.16,1491.84C1560.42,1491.03 1664.32,1489.76 1664.32,1489.76L1389.3,1918.81C1389.3,1918.81 1299.4,1890.61 1221.62,1866.22C1148.95,1843.43 1071.11,1843.06 998.219,1865.14C904.687,1893.49 786.474,1929.32 786.474,1929.32L830.695,1608.08Z",
    style: {
      fill: "rgb(23,64,212)"
    }
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,51.4616,-5.85918)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1056.56,
    cy: 1138.61,
    rx: 144.58,
    ry: 136.035,
    style: {
      fill: "white"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.558758,0,0,0.460853,6566.77,8609.23)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.78968,0,0,2.16989,-726.088,-1319.13)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1210.55,783.328L1217.88,875.608L1194.05,883.916L1002.92,1021.74L993.138,937.112L1176.61,798.509L1210.55,783.328Z",
    style: {
      fill: "rgb(6,19,75)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.78968,0,0,2.16989,-726.088,-1319.13)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M996.562,1132.75C996.562,1131.4 1006.15,931.812 1006.15,931.812L1010.11,805.778L1200.63,966.937L1217.42,1123.17C1217.42,1123.17 1217.88,1129.54 1217.88,1132.75C1217.88,1190.21 1168.29,1236.87 1107.22,1236.87C1046.14,1236.87 996.562,1190.21 996.562,1132.75Z",
    style: {
      fill: "rgb(255,200,161)"
    }
  }), _clipPath4 || (_clipPath4 = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M996.562,1132.75C996.562,1131.4 1006.15,931.812 1006.15,931.812L1010.11,805.778L1200.63,966.937L1217.42,1123.17C1217.42,1123.17 1217.88,1129.54 1217.88,1132.75C1217.88,1190.21 1168.29,1236.87 1107.22,1236.87C1046.14,1236.87 996.562,1190.21 996.562,1132.75Z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1120.52,1046.06C1120.52,1046.06 1120.52,1046.06 1120.52,1046.06C1141.32,1046.86 1157.77,1063.95 1157.77,1084.77C1157.77,1148.48 1157.77,1271.53 1157.77,1271.53L1384.15,1066.07L1150.1,964.475L1120.52,1046.06Z",
    style: {
      fill: "rgb(240,163,111)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M991.413,1145.18C991.413,1145.18 1010.22,1105.14 1024.57,1074.59C1034.34,1053.8 1055.26,1040.53 1078.23,1040.56C1089.09,1040.58 1098.07,1040.59 1098.07,1040.59L993.281,902.438L991.413,1145.18Z",
    style: {
      fill: "rgb(240,163,111)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1.78314,0.185352,0.152875,2.16196,3101.34,-1539.85)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1182.8,829.067L1204.4,814.798L1208.88,882.235C1208.88,882.235 1221.71,863.558 1240.16,873.229C1263.62,885.527 1266.42,940.973 1209.51,943.453L1177.21,953.994L1182.8,829.067Z",
    style: {
      fill: "rgb(255,200,161)"
    }
  }), _clipPath5 || (_clipPath5 = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1182.8,829.067L1204.4,814.798L1208.88,882.235C1208.88,882.235 1221.71,863.558 1240.16,873.229C1263.62,885.527 1266.42,940.973 1209.51,943.453L1177.21,953.994L1182.8,829.067Z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip5)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.996345,-0.08542,0.08542,0.996345,-69.2749,125.293)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1203.13,891.407C1203.13,891.407 1216.18,861.972 1240.16,873.229C1264.14,884.485 1266.42,940.973 1209.51,943.453L1198.6,926.866L1203.13,891.407Z",
    style: {
      fill: "rgb(240,163,111)"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.78968,0,0,2.16989,-742.346,-1319.13)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1203.13,891.407C1203.13,891.407 1216.18,861.972 1240.16,873.229C1264.14,884.485 1266.42,940.973 1209.51,943.453L1203.13,891.407Z",
    style: {
      fill: "rgb(255,200,161)"
    }
  }), _clipPath6 || (_clipPath6 = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1203.13,891.407C1203.13,891.407 1216.18,861.972 1240.16,873.229C1264.14,884.485 1266.42,940.973 1209.51,943.453L1203.13,891.407Z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip6)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,4.08555,17.198)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1203.13,891.407C1203.13,891.407 1216.18,861.972 1240.16,873.229C1264.14,884.485 1266.42,940.973 1209.51,943.453L1203.13,891.407Z",
    style: {
      fill: "rgb(240,163,111)"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.78968,0,0,2.16989,-726.088,-1319.13)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1192,806.895C1206.57,860.505 1213.32,916.317 1215.96,993.022C1215.96,993.022 1166.04,1074.4 1082.43,1035.85C1063.26,1027.01 1032.14,1000.99 1032.14,1000.99C1032.14,1000.99 1009.2,928.168 1014.33,833.582C1019.13,745.117 1054.75,751.427 1054.75,751.427L1192,806.895Z",
    style: {
      fill: "rgb(255,200,161)"
    }
  }), _clipPath7 || (_clipPath7 = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1192,806.895C1206.57,860.505 1213.32,916.317 1215.96,993.022C1215.96,993.022 1166.04,1074.4 1082.43,1035.85C1063.26,1027.01 1032.14,1000.99 1032.14,1000.99C1032.14,1000.99 1009.2,928.168 1014.33,833.582C1019.13,745.117 1054.75,751.427 1054.75,751.427L1192,806.895Z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip7)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1131.27,873.138L1158.74,944.985C1158.74,944.985 1139.54,958.416 1112.67,947.414L1131.27,873.138Z",
    style: {
      fill: "rgb(240,163,111)"
    }
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,46.074,-111.162)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1131.27,873.138L1158.74,944.985C1158.74,944.985 1053.25,957.559 1015.04,886.977L1131.27,873.138Z",
    style: {
      fill: "rgb(240,163,111)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.996725,-0.0808635,-0.0808635,0.996725,2320.61,90.5101)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1040.71,860.602L1070.97,845.406L1108.26,851.058L1092.94,863.021L1069.43,854.485L1040.71,860.602Z",
    style: {
      fill: "rgb(14,27,91)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.999523,0.0308927,-0.0308927,0.999523,27.0585,-32.5891)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1029.29,870.664L1056.11,850.009L1093.8,848.49L1081.02,863.139L1056.32,859.216L1029.29,870.664ZM1085.52,864.318L1100,848.49L1107.09,848.1L1091.45,865.162L1085.52,864.318Z",
    style: {
      fill: "rgb(14,27,91)"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.78968,0,0,2.16989,-726.088,-1319.13)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1035.21,773.294C1035.21,773.294 1152.65,853.022 1227.65,791.222C1227.65,791.222 1251.66,771.063 1267.88,715.731C1267.88,715.731 1234.4,697.261 1194.05,698.691L1196.88,679.63C1196.88,679.63 1129.37,674.664 1092.03,713.884L1092.03,687.487C1092.03,687.487 1052.64,731.568 1025.02,737.448C997.398,743.328 993.637,741.917 993.637,741.917C986.58,785.704 984.889,828.665 989.446,870.664C998.491,871.329 1004.56,875.182 1009.21,880.553C1009.21,880.553 1018.33,788.288 1035.21,773.294Z",
    style: {
      fill: "rgb(14,27,91)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.78968,-1.20453e-16,-9.93473e-17,-2.16989,-726.088,2499.42)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1161.6,875.563C1161.6,875.563 1177.8,868.956 1191.32,882.086C1191.32,882.086 1181.75,875.368 1161.19,879.642L1161.6,875.563Z",
    style: {
      fill: "rgb(14,27,91)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1.78968,1.20453e-16,-9.93473e-17,-2.16989,3302.68,2499.42)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1161.6,875.563C1161.6,875.563 1177.8,868.956 1191.32,882.086C1191.32,882.086 1181.91,875.309 1161.36,879.583L1161.6,875.563Z",
    style: {
      fill: "rgb(14,27,91)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.78968,0,0,2.16989,-726.088,-1319.13)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1085.09,977.305C1085.09,977.305 1106.57,984.859 1139.47,983.004L1138.77,999.097C1138.77,999.097 1102.36,1003.48 1085.09,977.305Z",
    style: {
      fill: "white"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1.00709,-0.296656,-0.216851,1.30652,2673.41,439.117)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1412.6,1507.59C1412.6,1507.59 1432.12,1583.67 1450.97,1657.15C1459.69,1691.15 1482.66,1719.89 1513.94,1735.95C1545.22,1752.02 1581.76,1753.84 1614.13,1740.94C1614.13,1740.94 1614.13,1740.94 1614.13,1740.94C1618.49,1739.21 1622.66,1737.08 1626.62,1734.57C1656.89,1714.75 1802.28,1615.14 1998.85,1406.14L1936.5,1347.73L1615.73,1533.51L1605.06,1473.86L1412.6,1507.59Z",
    style: {
      fill: "rgb(255,200,161)"
    }
  }), _clipPath8 || (_clipPath8 = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1412.6,1507.59C1412.6,1507.59 1432.12,1583.67 1450.97,1657.15C1459.69,1691.15 1482.66,1719.89 1513.94,1735.95C1545.22,1752.02 1581.76,1753.84 1614.13,1740.94C1614.13,1740.94 1614.13,1740.94 1614.13,1740.94C1618.49,1739.21 1622.66,1737.08 1626.62,1734.57C1656.89,1714.75 1802.28,1615.14 1998.85,1406.14L1936.5,1347.73L1615.73,1533.51L1605.06,1473.86L1412.6,1507.59Z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip8)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.817027,0.576599,0.576599,0.817027,1861.47,-627.978)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1413.72,1591.5C1413.72,1591.5 1561.88,1522.96 1667.77,1592.34L1568.11,1397.06L1388.51,1521.27L1413.72,1591.5Z",
    style: {
      fill: "rgb(240,163,111)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.999304,-0.0372988,-0.0372988,0.999304,6596.41,-6925.32)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4248.97,8389.02C4248.97,8389.02 4251.37,8344.53 4251.28,8334.34C4251.18,8324.01 4234.32,8320.17 4230.21,8330.86C4227.05,8339.1 4216.32,8373.05 4216.32,8373.05",
    style: {
      fill: "rgb(240,163,111)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.998724,0.050497,-0.050497,0.998724,105.883,-43.1051)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2040.91,1220.06L2042.96,1169.51L2053.45,1158.03L2068.49,1165.25L2070.3,1226.84L2053.78,1234.16L2040.91,1220.06Z",
    style: {
      fill: "rgb(240,163,111)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.998724,0.050497,-0.050497,0.998724,105.883,-43.1051)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2042.96,1169.51C2042.96,1169.51 2032.22,1147.18 2025.72,1133.65C2023.03,1128.06 2025.33,1121.41 2030.87,1118.74C2030.87,1118.74 2030.87,1118.74 2030.87,1118.74C2036.47,1116.05 2043.26,1118.29 2046.22,1123.82C2054.24,1138.74 2068.48,1165.26 2068.48,1165.26L2042.96,1169.51Z",
    style: {
      fill: "rgb(240,163,111)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.977708,-0.209968,-0.209968,0.977708,7833.9,-6125.46)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4141.07,8497.61L4108.21,8476.39L4078.44,8453.58L4068.36,8444.34L4032.45,8461.42L4086.04,8530.89L4184.86,8526.25C4184.86,8526.25 4183.51,8455.52 4182.12,8453.86C4180.6,8452.05 4145.36,8423.17 4135.96,8416.08C4123.03,8406.33 4112.68,8420.87 4117.63,8428.62C4126.59,8442.66 4142.5,8463.76 4142.5,8463.76L4141.07,8497.61Z",
    style: {
      fill: "rgb(240,163,111)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.967922,0.251251,-0.251251,0.967922,452.277,-402.081)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2040.91,1220.06L2042.96,1169.51L2068.3,1165.26C2068.3,1165.26 2069.4,1199.03 2069.96,1216.55C2070.18,1223.35 2069.12,1230.11 2066.84,1236.5C2060.86,1253.2 2049.22,1285.72 2049.22,1285.72L2040.91,1220.06Z",
    style: {
      fill: "rgb(240,163,111)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.967922,0.251251,-0.251251,0.967922,452.277,-402.081)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2042.96,1169.51C2042.96,1169.51 2032.21,1147.15 2025.7,1133.62C2023.02,1128.05 2025.33,1121.41 2030.88,1118.74C2030.88,1118.74 2030.88,1118.74 2030.88,1118.73C2036.47,1116.05 2043.24,1118.28 2046.17,1123.78C2054.13,1138.69 2068.31,1165.27 2068.31,1165.27L2066.49,1167.26L2042.96,1169.51Z",
    style: {
      fill: "rgb(240,163,111)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.9936,0.112959,-0.112959,0.9936,219.745,-160.166)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2040.91,1220.06L2042.96,1169.51L2053.45,1158.03L2068.49,1165.25L2070.3,1226.84L2053.78,1234.16L2040.91,1220.06Z",
    style: {
      fill: "rgb(255,200,161)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.9936,0.112959,-0.112959,0.9936,219.745,-160.166)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2042.96,1169.51C2042.96,1169.51 2032.23,1147.2 2025.72,1133.67C2023.03,1128.07 2025.34,1121.4 2030.89,1118.73C2030.89,1118.73 2030.89,1118.73 2030.89,1118.73C2036.48,1116.04 2043.25,1118.27 2046.2,1123.78C2054.21,1138.69 2068.48,1165.26 2068.48,1165.26L2042.96,1169.51Z",
    style: {
      fill: "rgb(255,200,161)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.977708,-0.209968,-0.209968,0.977708,7962.11,-6020.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4271.04,8513.23L4271.07,8513.26L4344.78,8469.54L4332.3,8450.52L4229.11,8414.11L4188.46,8369.13L4158.57,8372.77C4158.57,8372.77 4161.73,8402.24 4163.99,8423.42C4165.43,8436.82 4172.8,8448.88 4184.07,8456.26C4213.98,8475.86 4271.03,8513.24 4271.03,8513.24L4271.04,8513.23Z",
    style: {
      fill: "rgb(255,200,161)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.01166,-0.268886,0.207811,1.30898,-193.954,394.522)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1412.6,1507.59C1412.6,1507.59 1432.53,1585.26 1451.56,1659.44C1460.16,1692.99 1482.8,1721.22 1513.67,1736.92C1544.55,1752.61 1580.7,1754.26 1612.88,1741.44C1612.88,1741.44 1612.88,1741.44 1612.88,1741.44C1618.08,1739.37 1623.03,1736.7 1627.63,1733.49C1663.66,1707.9 1835.7,1582.45 1998.85,1406.14L1936.5,1347.73L1615.73,1533.51L1605.06,1473.86L1412.6,1507.59Z",
    style: {
      fill: "rgb(255,200,161)"
    }
  }), _clipPath9 || (_clipPath9 = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1412.6,1507.59C1412.6,1507.59 1432.53,1585.26 1451.56,1659.44C1460.16,1692.99 1482.8,1721.22 1513.67,1736.92C1544.55,1752.61 1580.7,1754.26 1612.88,1741.44C1612.88,1741.44 1612.88,1741.44 1612.88,1741.44C1618.08,1739.37 1623.03,1736.7 1627.63,1733.49C1663.66,1707.9 1835.7,1582.45 1998.85,1406.14L1936.5,1347.73L1615.73,1533.51L1605.06,1473.86L1412.6,1507.59Z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip9)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.817027,0.576599,0.576599,0.817027,1861.47,-627.978)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1413.72,1591.5C1413.72,1591.5 1561.88,1522.96 1667.77,1592.34L1568.11,1397.06L1388.51,1521.27L1413.72,1591.5Z",
    style: {
      fill: "rgb(240,163,111)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.999304,-0.0372988,-0.0372988,0.999304,6596.41,-6925.32)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4248.97,8389.02C4248.97,8389.02 4251.37,8344.53 4251.28,8334.34C4251.18,8324.01 4234.32,8320.17 4230.21,8330.86C4227.05,8339.1 4216.32,8373.05 4216.32,8373.05",
    style: {
      fill: "rgb(240,163,111)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.998724,0.050497,-0.050497,0.998724,105.883,-43.1051)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2040.91,1220.06L2042.96,1169.51L2053.45,1158.03L2068.49,1165.25L2070.3,1226.84L2053.78,1234.16L2040.91,1220.06Z",
    style: {
      fill: "rgb(240,163,111)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.998724,0.050497,-0.050497,0.998724,105.883,-43.1051)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2042.96,1169.51C2042.96,1169.51 2032.19,1147.11 2025.69,1133.59C2023.02,1128.05 2025.35,1121.39 2030.89,1118.73C2030.89,1118.73 2030.89,1118.73 2030.89,1118.73C2036.49,1116.03 2043.22,1118.22 2046.16,1123.7C2054.16,1138.6 2068.48,1165.26 2068.48,1165.26L2042.96,1169.51Z",
    style: {
      fill: "rgb(240,163,111)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.977708,-0.209968,-0.209968,0.977708,7833.9,-6125.46)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4141.07,8497.61L4108.21,8476.39L4078.44,8453.58L4068.36,8444.34L4032.45,8461.42L4086.04,8530.89L4184.86,8526.25C4184.86,8526.25 4183.51,8455.52 4182.12,8453.86C4180.6,8452.05 4145.36,8423.17 4135.96,8416.08C4123.03,8406.33 4112.68,8420.87 4117.63,8428.62C4126.59,8442.66 4142.5,8463.76 4142.5,8463.76L4141.07,8497.61Z",
    style: {
      fill: "rgb(240,163,111)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.967922,0.251251,-0.251251,0.967922,452.277,-402.081)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2040.91,1220.06L2042.96,1169.51L2068.3,1165.26C2068.3,1165.26 2069.39,1198.88 2069.96,1216.43C2070.18,1223.31 2069.11,1230.16 2066.79,1236.64C2060.79,1253.38 2049.22,1285.72 2049.22,1285.72L2040.91,1220.06Z",
    style: {
      fill: "rgb(240,163,111)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.967922,0.251251,-0.251251,0.967922,452.277,-402.081)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2042.96,1169.51C2042.96,1169.51 2032.18,1147.1 2025.68,1133.58C2023.02,1128.04 2025.35,1121.4 2030.88,1118.73C2030.88,1118.73 2030.88,1118.73 2030.88,1118.73C2036.49,1116.04 2043.22,1118.24 2046.14,1123.72C2054.1,1138.63 2068.31,1165.27 2068.31,1165.27L2066.49,1167.26L2042.96,1169.51Z",
    style: {
      fill: "rgb(240,163,111)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.9936,0.112959,-0.112959,0.9936,219.745,-160.166)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2040.91,1220.06L2042.96,1169.51L2053.45,1158.03L2068.49,1165.25L2070.3,1226.84L2053.78,1234.16L2040.91,1220.06Z",
    style: {
      fill: "rgb(255,200,161)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.9936,0.112959,-0.112959,0.9936,219.745,-160.166)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2042.96,1169.51C2042.96,1169.51 2032.19,1147.11 2025.69,1133.59C2023.02,1128.05 2025.35,1121.39 2030.89,1118.73C2030.89,1118.73 2030.89,1118.73 2030.89,1118.73C2036.49,1116.03 2043.22,1118.22 2046.16,1123.7C2054.16,1138.6 2068.48,1165.26 2068.48,1165.26L2042.96,1169.51Z",
    style: {
      fill: "rgb(255,200,161)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.977708,-0.209968,-0.209968,0.977708,7962.11,-6020.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4271.04,8513.23L4271.07,8513.26L4344.78,8469.54L4332.3,8450.52L4229.11,8414.11L4188.46,8369.13L4158.57,8372.77C4158.57,8372.77 4161.73,8402.24 4163.99,8423.42C4165.43,8436.82 4172.8,8448.88 4184.07,8456.26C4213.98,8475.86 4271.03,8513.24 4271.03,8513.24L4271.04,8513.23Z",
    style: {
      fill: "rgb(255,200,161)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.697335,0,0,0.744181,64.1439,280.207)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.78968,0,0,2.16989,-43.3243,-7134.57)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 214.153,
    y: 3668.14,
    width: 163.535,
    height: 145.9,
    style: {
      fill: "rgb(196,201,216)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.62826,0,0,1.92604,-291.476,-6507.25)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M377.688,3814.04L294.962,3724.33L214.153,3814.04L377.688,3814.04Z",
    style: {
      fill: "rgb(14,27,91)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.48104,0,0,1.79568,-1834.12,-13319.5)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1616.18,
    y: 7797.62,
    width: 32.56,
    height: 47.936,
    style: {
      fill: "rgb(14,27,91)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.906246,0,0,0.664117,218.533,-1749.55)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M345.003,3814.04C345.003,3814.04 344.92,3813.68 344.761,3813C336.976,3779.31 317.379,3757.15 295.582,3757.39C273.786,3757.62 254.362,3780.19 246.839,3814.04C246.838,3814.04 246.838,3814.04 246.838,3814.04L345.003,3814.04Z",
    style: {
      fill: "rgb(9,89,217)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.737,0,0,2.0959,14.5047,-6814.85)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 228.778,
    y: 3678.93,
    width: 85.65,
    height: 83.336,
    style: {
      fill: "white"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,0.893389,0.303275,88.767)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.332421,0,0,0.52624,354.372,-1012.83)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 214.153,
    y: 3668.14,
    width: 163.535,
    height: 145.9,
    style: {
      fill: "rgb(9,89,217)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.332421,0,0,0.52624,354.372,-922.317)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 214.153,
    y: 3668.14,
    width: 163.535,
    height: 145.9,
    style: {
      fill: "rgb(9,89,217)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.332421,0,0,0.52624,420.839,-1012.83)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 214.153,
    y: 3668.14,
    width: 163.535,
    height: 145.9,
    style: {
      fill: "rgb(9,89,217)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.332421,0,0,0.52624,420.839,-922.317)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 214.153,
    y: 3668.14,
    width: 163.535,
    height: 145.9,
    style: {
      fill: "rgb(9,89,217)"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.987423,0.204566,-0.12219,0.987423,69.7258,-220.764)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.36268,0,0,1.59723,-2459.99,-11703.2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2839.45,7494.39C2839.45,7483.88 2831.72,7475.35 2822.2,7475.35L2651.24,7475.35C2641.72,7475.35 2633.99,7483.88 2633.99,7494.39L2633.99,7603.4C2633.99,7613.91 2641.72,7622.44 2651.24,7622.44L2822.2,7622.44C2831.72,7622.44 2839.45,7613.91 2839.45,7603.4L2839.45,7494.39Z",
    style: {
      fill: "rgb(20,42,138)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.06639,0,0,1.33631,-1307.94,-9693.63)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2285.46,
    y: 7473.46,
    width: 262.696,
    height: 24.639,
    style: {
      fill: "rgb(188,194,222)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.42433,0,0,0.445886,173.408,-2964.74)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2285.46,
    y: 7473.46,
    width: 262.696,
    height: 24.639,
    style: {
      fill: "white"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.275867,0,0,0.445886,512.713,-2943.93)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2285.46,
    y: 7473.46,
    width: 262.696,
    height: 24.639,
    style: {
      fill: "white"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.03278,0,0,1.33631,-1191.54,-9644.49)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 2440.22,
    cy: 7527.25,
    r: 18.941,
    style: {
      fill: "rgb(188,194,222)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.03278,0,0,1.33631,-1165.29,-9644.49)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2440.22,7508.31C2450.68,7508.31 2459.16,7516.8 2459.16,7527.25C2459.16,7537.71 2450.68,7546.19 2440.22,7546.19C2429.77,7546.19 2421.28,7537.71 2421.28,7527.25C2421.28,7516.8 2429.77,7508.31 2440.22,7508.31ZM2440.22,7511.65C2448.84,7511.65 2455.83,7518.64 2455.83,7527.25C2455.83,7535.87 2448.84,7542.86 2440.22,7542.86C2431.61,7542.86 2424.62,7535.87 2424.62,7527.25C2424.62,7518.64 2431.61,7511.65 2440.22,7511.65Z",
    style: {
      fill: "rgb(188,194,222)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,-1.8545e-17,0,1,5.73886,-56.9108)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1.03278,0,0,1.33631,5386.58,-9485.53)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3374.2,7917.81C3374.2,7880.28 3343.73,7849.81 3306.2,7849.81L3096.19,7849.81C3058.66,7849.81 3028.19,7880.28 3028.19,7917.81C3028.19,7955.34 3058.66,7985.81 3096.19,7985.81L3306.2,7985.81C3343.73,7985.81 3374.2,7955.34 3374.2,7917.81Z",
    style: {
      fill: "white"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1.03278,0,0,1.33631,5373.82,-9633.89)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3138.98,
    cy: 7961.01,
    r: 65.962,
    style: {
      fill: "white"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1.39222,0,0,1.80138,6395.06,-13359.3)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3138.98,
    cy: 7961.01,
    r: 65.962,
    style: {
      fill: "white"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.03278,0,0,1.33631,-3933.72,-9606.6)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5803.24,7969.93L5768.72,8076.24L5807.56,8076.24L5796.27,8160.49L5878.57,8046.48L5835.94,8046.48L5863.74,7969.97L5803.24,7969.93Z",
    style: {
      fill: "rgb(255,226,112)"
    }
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGuy);
export default __webpack_public_path__ + "static/media/guy.4e382cfdddfdc3744786e25b5e0e1916.svg";
export { ForwardRef as ReactComponent };